export default __webpack_public_path__ + "static/media/heart-regular.f358882f.svg";